import { ArrayHelpers } from "formik";
import { SetStateAction } from "jotai";
import { cloneDeep } from "lodash";

export class FormikUtils {
  static readonly handleEnterKeyPress = (
    e: React.KeyboardEvent<HTMLInputElement>,
    action: () => void,
  ) => {
    switch (e.key) {
      case "Enter":
        action();
        break;
    }
  };

  static updateFieldValue<P extends object>(
    arrayHelpers: ArrayHelpers,
    index: number,
    initValue: P,
    fieldName: keyof P,
    value: any,
  ) {
    const newValue = cloneDeep(initValue);
    newValue[fieldName] = value;

    arrayHelpers.replace(index, newValue);
  }

  static deleteFieldValue(
    arrayHelpers: ArrayHelpers,
    index: number,
    updateRowKeys: (args_0: SetStateAction<string[] | undefined>) => void,
  ) {
    arrayHelpers.remove(index);
    updateRowKeys((prev) => prev?.filter((_, i) => i !== index) ?? []);
  }
}
